const slider_config_type = {
    1: {
        slidesPerView:  4,
        spaceBetween: 30,
        breakpoints: {
            '1': {
                slidesPerView: 1.5,
                slidesOffsetBefore: 13,
                slidesOffsetAfter: 13,
                spaceBetween: 20,
            },
            '500': {
                slidesPerView: 2.5,
                spaceBetween: 20,
                slidesOffsetBefore: 20,
                slidesOffsetAfter: 20,
            },
            '768': {
                slidesPerView: 4,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
            },
            '1024': {
                slidesPerView: 4,
                spaceBetween: 30,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
            }
        }
    },
    2: {
        slidesPerView:  2.91,
        spaceBetween: 30,
        breakpoints: {
            '1': {
                slidesPerView: 1.3,
                slidesOffsetBefore: 13,
                slidesOffsetAfter: 13,
                spaceBetween: 20,
            },
            '500': {
                slidesPerView: 1.5,
                spaceBetween: 20,
                slidesOffsetBefore: 20,
                slidesOffsetAfter: 20,
            },
            '768': {
                slidesPerView: 2.4,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
            },
            '1024': {
                slidesPerView: 2.91,
                spaceBetween: 30,
                slidesOffsetBefore: 30,
                slidesOffsetAfter: 30,
            }
        }
    },
    3: {
        slidesPerView:1
    },
    4: {
        slidesPerView:'auto',
        spaceBetween: 15,
        direction: "vertical",
        breakpoints: {
            '1': {
                slidesPerView:'auto',
                direction: 'horizontal'
            },
            '500': {
               direction: "vertical"
            },
            '768': {
           
            },
            '1024': {
               
            }
        }
    }
}

class CustomSlider extends HTMLElement {
    connectedCallback() {
        this.index = this.dataset.index || 1;
        const section = this;
        this.navigation = {
            navigation: {
                nextEl: section?.querySelector(".swiper-button-next") || null,
                prevEl: section?.querySelector(".swiper-button-prev") || null,
            },
        };

        this.pagination = {
            pagination: {
                el: section?.querySelector(".swiper-pagination") || null,
                type: "progressbar",
            },
        };

        this.config = {
            ...slider_config_type[this.index],
            ...this.navigation,
            ...this.pagination
        };

        this.swiper = new Swiper(this, this.config);

        if (this.classList.contains('swiper-product')) {
            this.initThumbSlider();
        }
    }

    initThumbSlider() {
        const thumbSlider = this.closest('.shopify-section')?.querySelector('custom-slider.swiper-thumb');
        this.checkThumbSlider(thumbSlider);
    }

    checkThumbSlider(thumbSlider) {
        const thumbSwiper = thumbSlider?.swiper;

        if (thumbSwiper) {
            this.swiper.params.thumbs = {
                swiper: thumbSwiper
            };
            this.swiper.thumbs.init();
            this.swiper.thumbs.update();
        } else {
            setTimeout(() => this.checkThumbSlider(thumbSlider), 100);
        }
    }
}

customElements.define('custom-slider', CustomSlider);
